function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import findIndex from 'lodash/findIndex';
import { css, color, spacing, StyleSheet } from "../../../styles/theme";
import { Z_DEPTH_SHADOWS, FOCUS_DIRECTION } from "../../../constants/sharedConstants";
import { keyCodes } from "../../../constants/keyCodes";
import { isFocusedElement } from "../../../utils/a11yUtils";
import DropDownListItem from "./DropDownListItem";
var CONFIG = {
  boxShadow: Z_DEPTH_SHADOWS[1],
  defaultMinWidth: 0,
  defaultMaxWidth: 240,
  defaultMaxHeight: '100%',
  defaultFocusIndex: -1
};
var styles = StyleSheet.create({
  DropDownList: {
    listStyle: 'none',
    width: 'fit-content',
    padding: 0,
    marginBottom: 0,
    overflow: 'auto',
    backgroundColor: color.white
  }
});
var DropDownList = /*#__PURE__*/function (_React$Component) {
  function DropDownList() {
    var _this;
    _classCallCheck(this, DropDownList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DropDownList, [].concat(args));
    _defineProperty(_this, "dropdownList", undefined);
    _defineProperty(_this, "getCurrentFocusIndex", function () {
      if (_this.dropdownList) {
        var currentIndex = findIndex(_this.dropdownList.children, isFocusedElement);
        if (currentIndex > CONFIG.defaultFocusIndex) {
          return currentIndex;
        } else {
          // Allow currentSelectedIndex to be passed as props,
          // for if the list keeps track of the currently selected item
          var currentSelectedIndex = _this.props.currentSelectedIndex;
          if (currentSelectedIndex !== undefined && currentSelectedIndex > CONFIG.defaultFocusIndex) {
            return currentSelectedIndex;
          }
        }
      }
      return CONFIG.defaultFocusIndex;
    });
    _defineProperty(_this, "getNextFocusIndex", function (currentIndex, direction) {
      if (_this.dropdownList) {
        var lastItemIndex = _this.dropdownList.children.length - 1;
        if (direction === FOCUS_DIRECTION.previous) {
          return currentIndex === 0 ? lastItemIndex : currentIndex - 1;
        }
        return currentIndex === lastItemIndex ? 0 : currentIndex + 1;
      }
      return CONFIG.defaultFocusIndex;
    });
    _defineProperty(_this, "setFocusOnNextItem", function (currentIndex, direction) {
      var newIndex = _this.getNextFocusIndex(currentIndex, direction);
      if (_this.dropdownList) {
        var children = _this.dropdownList.children;
        if (children[newIndex].tabIndex === -1) {
          _this.setFocusOnNextItem(newIndex, direction);
        } else {
          children[newIndex].focus();
        }
      }
    });
    _defineProperty(_this, "selectItem", function (index) {
      if (_this.dropdownList && _this.dropdownList.children[index]) {
        _this.dropdownList.children[index].click();
      }
    });
    _defineProperty(_this, "resetFocus", function () {
      var currentFocusIndex = _this.getCurrentFocusIndex();
      if (_this.dropdownList && _this.dropdownList.children[currentFocusIndex]) {
        _this.dropdownList.children[currentFocusIndex].blur();
        _this.onBlur();
      }
    });
    _defineProperty(_this, "onFocus", function (ev) {
      if (_this.props.onFocus) {
        if (ev) {
          ev.preventDefault();
        }
        _this.props.onFocus();
      }
    });
    _defineProperty(_this, "onClick", function (ev, listItemValue) {
      if (_this.props.onClick) {
        _this.props.onClick(ev, listItemValue);
      }
    });
    _defineProperty(_this, "onBlur", function (ev) {
      if (_this.props.onBlur) {
        if (ev) {
          ev.preventDefault();
        }
        _this.props.onBlur();
      }
    });
    _defineProperty(_this, "onKeyDown", function (ev) {
      var currentIndex = _this.getCurrentFocusIndex();
      switch (ev.keyCode) {
        case keyCodes.up:
        case keyCodes.left:
          ev.preventDefault();
          _this.setFocusOnNextItem(currentIndex, FOCUS_DIRECTION.previous);
          break;
        case keyCodes.down:
        case keyCodes.right:
          ev.preventDefault();
          _this.setFocusOnNextItem(currentIndex, FOCUS_DIRECTION.next);
          break;
        case keyCodes.space:
        case keyCodes.enter:
          ev.preventDefault();
          _this.selectItem(currentIndex);
          break;
        case keyCodes.esc:
          ev.preventDefault();
          _this.resetFocus();
          break;
      }
    });
    return _this;
  }
  _inherits(DropDownList, _React$Component);
  return _createClass(DropDownList, [{
    key: "getBorderStyle",
    value: function getBorderStyle() {
      var _this$props = this.props,
        borderColor = _this$props.borderColor,
        showBorder = _this$props.showBorder;
      return showBorder ? {
        border: "1px solid ".concat(borderColor)
      } : {
        boxShadow: CONFIG.boxShadow
      };
    }
  }, {
    key: "getSizingStyle",
    value: function getSizingStyle() {
      var _this$props2 = this.props,
        maxHeight = _this$props2.maxHeight,
        maxWidth = _this$props2.maxWidth,
        minWidth = _this$props2.minWidth;
      var actualMaxWidth = maxWidth || CONFIG.defaultMaxWidth;
      if (minWidth && minWidth > actualMaxWidth) {
        actualMaxWidth = minWidth;
      }
      return {
        maxHeight: maxHeight ? "".concat(maxHeight, "px") : CONFIG.defaultMaxHeight,
        maxWidth: "".concat(actualMaxWidth, "px"),
        minWidth: minWidth ? "".concat(minWidth, "px") : CONFIG.defaultMinWidth
      };
    }
  }, {
    key: "renderListItems",
    value: function renderListItems() {
      var _this2 = this;
      return this.props.listItemData.map(function (listItem, index) {
        var children = listItem.children,
          isDisabled = listItem.isDisabled,
          label = listItem.label,
          onClick = listItem.onClick,
          value = listItem.value;
        var onClickCallback = function onClickCallback(ev, listItemValue) {
          _this2.onClick(ev, listItemValue);
          if (onClick) {
            onClick(ev, listItemValue);
          }
        };
        return /*#__PURE__*/React.createElement(DropDownListItem, {
          key: index,
          label: label,
          isDisabled: isDisabled,
          onClick: onClickCallback,
          value: value
        }, children);
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this3 = this;
      return React.Children.map(this.props.children, function (child) {
        if (! /*#__PURE__*/React.isValidElement(child)) {
          return null;
        }
        var onClickHandler = function onClickHandler(ev, listItemValue) {
          _this3.onClick(ev, listItemValue);
          if (child.props && typeof child.props.onClick === 'function') {
            child.props.onClick(ev, listItemValue);
          }
        };

        // $FlowFixMe
        return /*#__PURE__*/React.cloneElement(child, {
          onClick: onClickHandler
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props3 = this.props,
        htmlAttributes = _this$props3.htmlAttributes,
        listItemData = _this$props3.listItemData,
        renderListItems = _this$props3.renderListItems,
        rootClassName = _this$props3.rootClassName,
        style = _this$props3.style;
      var mergedStyles = _objectSpread(_objectSpread(_objectSpread({}, style), this.getSizingStyle()), this.getBorderStyle());
      return (
        /*#__PURE__*/
        // Need this outer div because ReactModal adds a div to the outermost
        // element, which interferes with focus calculations
        React.createElement("div", {
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onKeyDown: this.onKeyDown
        }, /*#__PURE__*/React.createElement("ul", _extends({
          role: "menu",
          tabIndex: -1,
          style: mergedStyles,
          ref: function ref(dropdownList) {
            return _this4.dropdownList = dropdownList;
          }
        }, css(rootClassName, styles.DropDownList), htmlAttributes), renderListItems && renderListItems(listItemData), !renderListItems && this.renderListItems(), this.renderChildren()))
      );
    }
  }]);
}(React.Component);
_defineProperty(DropDownList, "defaultProps", {
  borderColor: color.primary,
  listItemData: [],
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {}
});
export { DropDownList as default };